import { useFocusable, FocusContext } from "@noriginmedia/norigin-spatial-navigation";
import { useNavigate } from "react-router-dom";
import { useCallback, useMemo } from "react";
import { getOptimizedImageForType } from "../../utils/cms.utils";
import ContentTag from "../../utils/tag";
import OptimizedImage from "../common/OptimizedImage";
import { useInputMode } from "../../utils/hooks/useInputMode";
import LazyRow from "../common/LazyRow";

const MovieItem = ({ item = {}, onFocus }) => {
  const navigate = useNavigate();
  const { contentPhotos, tags, slug, contentType, _id } = item;
  const { focused, ref, focusSelf } = useFocusable({
    onFocus,
    onEnterPress: () => {
      navigate(`/${contentType?.kind}/${slug}`);
    },
    focusKey: "content_" + _id,
  });

  const { setMouseFocus } = useInputMode();
  const handleMouseEnter = useCallback(() => {
    setMouseFocus(true);
    focusSelf();
  }, [focusSelf, setMouseFocus]);

  // Get optimized image with LQIP and WebP support (w=200, q=90 for grid cards)
  const imageData = getOptimizedImageForType("verticalCover", contentPhotos, "TV", { width: 350, quality: 90, format: 'jpeg' });

  return (
    <div
      ref={ref}
      className={"legacy-moftabakh-card" + (focused ? " is-focused" : "")}
      onClick={() => navigate(`/${contentType?.kind}/${slug}`)}
      onMouseEnter={handleMouseEnter}
    >
      <OptimizedImage
        src={imageData.src}
        className="absolute inset-0 w-full h-full"
        style={{
          objectFit: 'cover',
          borderRadius: "inherit",
        }}
      />
      {tags?.[0] && <ContentTag label={tags?.[0]} />}
      <div className="legacy-moftabakh-focus-border" />
      <div className="legacy-moftabakh-overlay">
        <span className="legacy-moftabakh-title">{item.title}</span>
        <span className="legacy-moftabakh-year">{item.year}</span>
      </div>
    </div>
  );
};

var ITEMS_PER_ROW = 5;

function chunkArray(array, size) {
  var result = [];
  for (var i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

export const CategoriesSlider = ({ movies, onFocus }) => {
  const navigate = useNavigate();
  const { ref, focusKey } = useFocusable();

  var chunkedItems = useMemo(
    function () {
      if (!movies || movies.length === 0) return [];
      return chunkArray(movies, ITEMS_PER_ROW);
    },
    [movies]
  );

  if (!movies || movies.length < 1) return null;

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref}>
        {chunkedItems.map(function (rowItems, rowIndex) {
          return (
            <LazyRow key={"moftabakh_row_" + rowIndex} index={rowIndex}>
              <div className="legacy-moftabakh-grid">
                {rowItems.map((item) => (
                  <MovieItem
                    item={item}
                    key={item._id}
                    onEnterPress={() =>
                      navigate(`/${item.contentType.kind}/${item.slug}`)
                    }
                    onFocus={onFocus}
                  />
                ))}
              </div>
            </LazyRow>
          );
        })}
      </div>
    </FocusContext.Provider>
  );
};
